module.exports = __webpack_public_path__ + "static/media/share.e0c724ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/share.jpg
// module id = 344
// module chunks = 2